import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    FieldError
} from '../../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    TextField,
    CheckboxWithLabel,
    Select
} from 'formik-material-ui';

import {
    Grid,
    IconButton,
    InputLabel,
    FormControl,
    MenuItem,
    Typography
} from '@material-ui/core';

import { useTranslation } from "react-i18next";

import { BaseMenuItem } from './BaseMenuItem';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    formControl: {
        width: '100%'
    },
    progress: {
        color: "black"
    },
    pickerBox: {
        marginLeft: "-6px"
    }
}));

export const EmailMenuItem = ({
    item,
    icons,
    formRef,
    errors,
    validationSchema,
    disabled,
    upload,
    onUpdated,
    onRemove,
    onSubmit,
    ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    const { t, i18n } = useTranslation();

    return <BaseMenuItem
        item={item}
        icons={icons}
        formRef={formRef}
        errors={errors}
        validationSchema={validationSchema}
        disabled={disabled}
        upload={upload}
        onUpdated={onUpdated}
        onRemove={onRemove}
        onSubmit={onSubmit}>
        <Grid item xs={12}>
            <Field
                className={classes.field}
                name="props.email"
                type="text"
                variant="outlined"
                label={t("LabelEmail")}
                component={TextField}
                disabled={disabled}
            />
            <FieldError
                name={`[${item.id}].props.email`}
                errors={errors}
            />
        </Grid>
    </BaseMenuItem>
}